module.exports = __webpack_public_path__ + "static/media/no-sms-orange-48x48.0c7b64d9.svg";